import { createRenderEffect, JSXElement, mergeProps } from 'solid-js';
import Prism from 'prismjs';
import { CodeBlockLanguages } from '~/components/CodeBlock/CodeBlock.tsx';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-go';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-json';
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import logger from '~/utils/logger';

export enum PrismThemes {
  ONE_LIGHT = 'one-light',
  ATOM_DARK = 'atom-dark'
}

type PrimsBlockProps = {
  content: string;
  language: CodeBlockLanguages;
  showLineNumbers?: boolean;
  theme?: PrismThemes;
};

const loadPrismTheme = async (theme: PrismThemes) => {
  try {
    await import(`./prism-${theme}.scss`);
  } catch (e) {
    logger.error(`Error loading theme for Prism`);
  }
};

export default function PrimsBlock(props: PrimsBlockProps): JSXElement {
  const merged = mergeProps(
    {
      theme: PrismThemes.ONE_LIGHT,
      showLoneNumbers: false
    },
    props
  );

  // const getCodeTokens = (code: string, language: CodeBlockLanguages) => {
  //   return Prism.highlight(code, Prism.languages[language], language);
  // };

  createRenderEffect(async () => {
    await loadPrismTheme(merged.theme);
    setTimeout(() => {
      Prism.highlightAll();
    });
  });

  return (
    <pre
      classList={{
        'line-numbers': merged.showLineNumbers
      }}
    >
      {/*<code innerHTML={getCodeTokens(merged.content, merged.language)}></code>*/}
      <code
        class={`language-${merged.language} leading-loose font-code tracking-wider`}
      >
        {merged.content}
      </code>
    </pre>
  );
}
